module.exports = __webpack_public_path__ + "public/assets/img/error-dark.145f4548.svg";